import { isDateObject } from '../util';

const booleanTypes = [
  'FIELD_YES_NO',
  'FIELD_AGREEMENT_CHECKBOX',
];

const comparableTypes = [
  'FIELD_INTEGER',
  'FIELD_DATE',
  'FIELD_TIME',
  'FIELD_DATETIME',
  'FIELD_FLOAT1',
  'FIELD_FLOAT2',
  'FIELD_MONEY',
  'FIELD_DURATION',
  'FIELD_FORMULA',
];

const floatTypes = [
  'FIELD_FLOAT1',
  'FIELD_FLOAT2',
  'FIELD_MONEY',
  'FIELD_FORMULA',
];

const singleFileUploadTypes = [
  'FIELD_IMAGE_UPLOAD',
];

const multipleFileUploadTypes = [
  'FIELD_IMAGE_UPLOAD_MULTIPLE',
];

const documentUploadTypes = [
  'FIELD_DOCUMENT_UPLOAD',
];

const readOnlyTypes = [
  'FIELD_LABEL',
  'FIELD_SUBSECTION',
  'FIELD_DISPLAY_TEXT',
  'FIELD_DISPLAY_IMAGE',
];

const allFileUploadTypes = singleFileUploadTypes.concat(multipleFileUploadTypes).concat(documentUploadTypes);

class FieldType {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.defined_as = data.defined_as || null;
    this.name = data.name || '';
    this.active = data.active || true;
    this.has_options = data.has_options || false;
    this.in_recap = data.in_recap || null;
    this.programs_id = data.programs_id || null;
  }

  get isBoolean() {
    return booleanTypes.indexOf(this.defined_as) !== -1;
  }

  get isDate() {
    return this.defined_as === 'FIELD_DATE';
  }

  get isTime() {
    return this.defined_as === 'FIELD_TIME';
  }

  get isDateTime() {
    return this.defined_as === 'FIELD_DATETIME';
  }

  get isInteger() {
    return this.defined_as === 'FIELD_INTEGER';
  }

  get isDuration() {
    return this.defined_as === 'FIELD_DURATION';
  }

  get isFloat() {
    return floatTypes.indexOf(this.defined_as) !== -1
  }

  get isNumeric() {
    return this.isInteger || this.isFloat;
  }

  get isFileUpload() {
    return allFileUploadTypes.indexOf(this.defined_as) !== -1;
  }

  get isMultipleFileUpload() {
    return multipleFileUploadTypes.indexOf(this.defined_as) !== -1;
  }

  get isDocumentUpload() {
    return documentUploadTypes.indexOf(this.defined_as) !== -1;
  }

  get isImageFileUpload() {
    return this.isFileUpload && this.defined_as.indexOf('IMAGE' !== -1);
  }

  get supportsComparison() {
    return comparableTypes.indexOf(this.defined_as) !== -1;
  }

  get isReadOnly() {
    return readOnlyTypes.indexOf(this.defined_as) !== -1;
  }

  validateResponse(fieldResponse) {
    let errors = [];
    let value = fieldResponse.currentValue;
    if (!fieldResponse.isEmpty) {
      if (this.isInteger) {
        if (!value.toString().match(/^\d*$/)) {
          errors.push({
            fieldResponse,
            key: 'ERROR_INVALID_INTEGER',
            message: "Must be a valid integer",
          });
        }
      } else if (this.isDateTime) {
        if (isDateObject(value)) {
          // Good; it's a date
        } else if (!value.toString().match(/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/)) {
          errors.push({
            fieldResponse,
            key: 'ERROR_INVALID_DATETIME',
            message: "Invalid date/time format. Please use YYYY-MM-DD HH:MM",
          });
        }
      } else if (this.isDate) {
        if (isDateObject(value)) {
          // Good; it's a date
        } else if (!value.toString().match(/^\d{4}-\d{2}-\d{2}/)) {
          errors.push({
            fieldResponse,
            key: 'ERROR_INVALID_DATE',
            message: "Invalid date format. Please use YYYY-MM-DD",
          });
        }
      } else if (this.isDuration) {
        // if (!value.toString().match(/^(\d{1,}:)?\d{1,2}$/)) {
        //   errors.push({
        //     fieldResponse,
        //     key: 'ERROR_INVALID_DURATION',
        //     message: "Invalid duration format. Please use hh:mm",
        //   });
        // }
      } else if (this.isFloat) {
        if (!value.toString().match(/^\d*\.?\d+$/)) {
          errors.push({
            fieldResponse,
            key: 'ERROR_INVALID_NUMERIC',
            message: 'Invalid numeric format',
          });
        }
      }
    }
    return errors;
  }
}

export default FieldType;
